import { Sparkles, Target, Building2, Users, Palette } from "lucide-react";

export const PARSE_TYPES = [
  { id: "auto", label: "Auto-Detect", icon: Sparkles, description: "AI determines what type of document this is", color: "text-ism-teal" },
  { id: "icp", label: "ICP / Target Market", icon: Target, description: "Extract ideal customer profile details", color: "text-blue-400" },
  { id: "company_info", label: "Company Info", icon: Building2, description: "Extract business name, products, value prop", color: "text-purple-400" },
  { id: "accounts", label: "Account List", icon: Building2, description: "Extract companies from a list", color: "text-green-400" },
  { id: "contacts", label: "Contact List", icon: Users, description: "Extract people/prospects from a list", color: "text-orange-400" },
  { id: "brand", label: "Brand Guidelines", icon: Palette, description: "Extract brand voice and messaging", color: "text-pink-400" },
];

export const ACCEPT = ".pdf,.doc,.docx,.txt,.csv,.xlsx,.xls";

export const PASTE_PLACEHOLDER = "Paste your data here...\n\nExamples:\n• ICP description\n• List of company names\n• Contact information\n• Brand guidelines text";

/* Which endpoint + form fields a parse request needs. */
export const buildParseRequest = ({ mode, file, pastedText, parseType, userId, instanceId, applyToInstance }) => {
  const form = new FormData();
  form.append("userId", userId);
  if (instanceId) form.append("instanceId", instanceId);
  if (mode === "file" && file.name.toLowerCase().endsWith(".csv")) {
    form.append("file", file);
    return { url: "/smart/parse/csv", form };
  }
  form.append("applyToInstance", applyToInstance);
  if (mode === "file") {
    form.append("file", file);
    form.append("documentType", parseType);
    return { url: "/smart/parse/document", form };
  }
  form.append("text", pastedText);
  form.append("parseType", parseType === "auto" ? "icp" : parseType);
  return { url: "/smart/parse/text", form };
};

export const successMessage = (data) => {
  const count = data.recordsCreated || data.importedRows || 0;
  if (count > 0) return `Successfully imported ${count} records!`;
  if (data.instanceUpdated) return "Workspace updated with extracted data!";
  return "Data extracted successfully!";
};
